module.exports = __webpack_public_path__ + "img/brand_logo_brand_guide_brand_template_card.04108fcd.svg";